<template>
    <div>
        <div v-if="showVertical">
            <ul class="list-group">
                <li @click="onClickDocumentId()" :key="page.id" v-for="page in pages" :class="{active: page.id == selectedPageId}" class="list-group-item list-group-item-action fa-sm" style="border:none;padding:3 0 3 0">{{ page.id }}</li>
            </ul>        
        </div>
        <div v-if="!showVertical" class="fa-sm">
            <div @click="onClickDocumentId()" id="leftbox" :key="page.id" v-for="page in pages" :class="{horizonalActive: page.id == selectedPageId}">{{ page.id }}</div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "InvoicePages",
        components: {},
        data: () => ({
            pages: [],
            selectedPageId: null
        }),   
        props: {
          selectedInvoiceId: null,
          showVertical: Boolean
        },
        computed: {
            ...mapGetters('fmwebapp',['invoices']),
            ...mapGetters('errors', ['statusCode', 'notFoundError'])
        },
        methods: {
            ...mapActions('fmwebapp', ['all', 'errors']),
            onClickDocumentId() {
                this.selectedPageId = event.target.innerHTML

                var pageElement = this.pages.find(x => x.id == this.selectedPageId)
                if (pageElement !== undefined)
                {
                    pageElement.isActive = true;
                    this.$emit('changeInvoiceImage', pageElement.invoicePicture)
                }

                this.pages.forEach((page) =>{
                    if (page !== pageElement)
                    {
                        page.isActive = false
                    }
                });
            }            
        },
        created() {
            var vm = this;
            vm.all({
                resource: 'invoices/pages',
                queryParameters: [
                    {key: 'documentId', value: vm.selectedInvoiceId}
                ],
                cacheresult: false
            }).then((data) => {
                vm.pages = data.result
                vm.selectedPageId = this.selectedInvoiceId
                this.$emit('onPagesLoaded', data.result.length)
            });            
        }
    }
</script>
<style>
    .expansionPanel{
        border-radius: 0 !important;
    }

    .horizonalActive {
        color: #fff;
        background-color: #007bff;
    }    

    #leftbox {
        float:left; 
        margin: 10px;
    }
    #middlebox{
        float:left; 
        margin: 10px;
    }
    #rightbox{
        float:right;
        margin: 10px;
    }   
</style>